import React from 'react';

import cn from 'classnames';

import { IForm } from '@entities/AdminConversationCategory/model/types';
import { CustomModal } from '@shared/ui';

import cls from './ConversationClientModal.module.css';
import { useConversationClientModal } from '../lib/hooks/useConversationClientModal';

interface ConversationClientModalProps {
    classes?: string;
    close: () => void;
    onSendSurvey?: () => void;
    prevData?: IForm;
}

export const ConversationClientModal = ({
    classes,
    close,
    onSendSurvey,
    prevData,
}: ConversationClientModalProps) => {
    const { closeModal, conversationClientData, typeMapping } = useConversationClientModal({
        close,
        onSendSurvey,
        prevData,
    });

    return (
        <CustomModal
            isOpen
            onHideModal={closeModal}
            contentClasses={cn(cls.ConversationClientModal, [classes])}
        >
            <CustomModal.Header>
                {prevData ? prevData.title : conversationClientData.title}
            </CustomModal.Header>

            {typeMapping[prevData ? prevData.type : conversationClientData.type]}
        </CustomModal>
    );
};
